import React from 'react';
import { useParams } from 'react-router-dom';

import CaptureBadgeDesignPreview from '@domains/Badges/Capture/Preview';
import CaptureWidgetPages from '@domains/WidgetPages/Capture';

import { BADGES, WIDGET_PAGES } from './constants';

const Capture = () => {
  const { resourceType } = useParams();

  switch (resourceType) {
    case WIDGET_PAGES: {
      return <CaptureWidgetPages />;
    }
    case BADGES: {
      return <CaptureBadgeDesignPreview />;
    }
    default: {
      return <>Unknown resource type</>;
    }
  }
};

export default Capture;
